export * from '../src/common/diff-permalink';
